import { Grid, Typography } from '@mui/material';
import { usePqrStatusManagement } from './hook';
import { PqrStatusManagementProps } from './props';
import dayjs from 'dayjs';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import FieldText from '../../../../../components/general/fields/fieldText';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../redux/store';

export const PqrStatusManagement = (props: PqrStatusManagementProps) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const {
        formik,
        statusList,
        isClosingStatus,
        isFollowUpStatus,
        isStatusExtensionInfo,
        isStatusReceptionInfo,
        isStatusSolution,
        isStatusOpen,
        isStatusProcessed,
        isStatusExtension,
        isStatusCancelled,
        minClosedDate,
        maxClosedDate,
        maxNotificationProcedureDate,
        minSuspensionDate,
        minReactivationDate,
        minNotificationResponseDate,
        minResponseDate,
        isStatusProcessedInFirstLoad,
        isWorngMovement,
    } = usePqrStatusManagement(props);

    const {
        isPhysicalReceptionChannel,
        isEmailReceptionChannel,
        isFaxReceptionChannel,
        isSocialMediaReceptionChannel,
    } = props;

    const isDisabledSacAndFurag = () => {
        if (type === 'admin') {
            return false;
        }
        if (type !== 'admin' && !formik.values.processingDate) {
            return false;
        }
        if (
            type !== 'admin' &&
            formik.values.processingDate &&
            !formik.values.editFuragAndSac
        )
            return true;
    };

    return (
        <>
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                pt="20px"
                id="CHANGE_STATUS"
            >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Cambiar estado PQR
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(statusList)}
                        label="Estado"
                        name="status"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.status}
                        errors={
                            isWorngMovement
                                ? 'Este movimiento no es permitido, ya que supero el tiempo para aplicar ampliación de información, el cual es de 10 días hábiles.'
                                : formik.errors.status
                        }
                        value={formik.values.status}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('status', value)
                        }
                    />
                </Grid>
                <Grid item xs={0} sm={6} md={8} />
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de radicación cliente"
                        name="customerFilingDate"
                        size="small"
                        required={
                            isClosingStatus ||
                            isFollowUpStatus ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusSolution ||
                            isStatusProcessed ||
                            isStatusExtension
                        }
                        touched={formik.touched.customerFilingDate}
                        errors={formik.errors.customerFilingDate?.toString()}
                        value={formik.values.customerFilingDate}
                        onChange={(value) =>
                            formik.setFieldValue(
                                'customerFilingDate',
                                value,
                                true
                            )
                        }
                        disabled={
                            !(
                                isPhysicalReceptionChannel ||
                                isEmailReceptionChannel
                            ) ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusExtension ||
                            isStatusSolution ||
                            isClosingStatus
                        }
                        maxDate={maxNotificationProcedureDate}
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de notificación trámite"
                        name="notificationProcedureDate"
                        size="small"
                        required={
                            isClosingStatus ||
                            isFollowUpStatus ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusSolution ||
                            isStatusProcessed ||
                            isStatusExtension
                        }
                        touched={formik.touched.notificationProcedureDate}
                        errors={formik.errors.notificationProcedureDate?.toString()}
                        value={formik.values.notificationProcedureDate}
                        onChange={(value) =>
                            formik.setFieldValue(
                                'notificationProcedureDate',
                                value,
                                true
                            )
                        }
                        disabled={
                            (!isPhysicalReceptionChannel &&
                                !isEmailReceptionChannel &&
                                !isFaxReceptionChannel &&
                                !isSocialMediaReceptionChannel) ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusExtension ||
                            isStatusSolution ||
                            isClosingStatus
                        }
                        minDate={dayjs(formik.values.customerFilingDate)}
                        maxDate={dayjs(props.createdAt)}
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de registro sistema"
                        name="createdAt"
                        size="small"
                        disabled
                        value={dayjs(props.createdAt).subtract(5, 'hours')}
                        required={
                            isClosingStatus ||
                            isFollowUpStatus ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusSolution ||
                            isStatusProcessed ||
                            isStatusExtension
                        }
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha trámite"
                        name="processingDate"
                        size="small"
                        maxDate={dayjs()}
                        disabled={!isStatusProcessedInFirstLoad}
                        touched={formik.touched.processingDate}
                        errors={formik.errors.processingDate?.toString()}
                        value={formik.values.processingDate}
                        minDate={dayjs(props.createdAt).subtract(5, 'hours')}
                        onChange={(value) =>
                            formik.setFieldValue('processingDate', value, true)
                        }
                        required={
                            isClosingStatus ||
                            isFollowUpStatus ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusSolution ||
                            isStatusProcessed ||
                            isStatusExtension
                        }
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de suspensión"
                        name="suspensionDate"
                        size="small"
                        disabled={
                            isStatusOpen ||
                            isStatusCancelled ||
                            isStatusProcessed ||
                            isFollowUpStatus ||
                            isStatusReceptionInfo ||
                            isStatusExtension ||
                            isStatusSolution ||
                            isClosingStatus ||
                            (isStatusExtensionInfo && isWorngMovement)
                        }
                        touched={formik.touched.suspensionDate}
                        errors={formik.errors.suspensionDate?.toString()}
                        value={formik.values.suspensionDate}
                        minDate={minSuspensionDate}
                        maxDate={
                            formik.values.responseDate
                                ? dayjs(formik.values.responseDate)
                                : dayjs()
                        }
                        onChange={(value) =>
                            formik.setFieldValue('suspensionDate', value, true)
                        }
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        label="Enviar email - Ampliación de la información"
                        checked={Boolean(
                            formik.values.sendEmailExpansionInformation
                        )}
                        disabled={!isStatusExtensionInfo}
                        onChange={() => {
                            formik.setFieldValue(
                                'sendEmailExpansionInformation',
                                !formik.values.sendEmailExpansionInformation
                            );
                        }}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <DateTimePickerField
                        label="Fecha de reactivación"
                        name="reactivationDate"
                        size="small"
                        disabled={
                            !isStatusReceptionInfo ||
                            !formik.values.suspensionDate
                        }
                        touched={formik.touched.reactivationDate}
                        errors={formik.errors.reactivationDate?.toString()}
                        value={formik.values.reactivationDate}
                        minDate={minReactivationDate}
                        maxDate={
                            formik.values.responseDate
                                ? dayjs(formik.values.responseDate)
                                : dayjs()
                        }
                        onChange={(value) =>
                            formik.setFieldValue(
                                'reactivationDate',
                                value,
                                true
                            )
                        }
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de prórroga"
                        name="extensionDate"
                        size="small"
                        disabled={!isStatusExtension}
                        touched={formik.touched.extensionDate}
                        errors={formik.errors.extensionDate?.toString()}
                        value={formik.values.extensionDate}
                        minDate={minReactivationDate}
                        onChange={(value) =>
                            formik.setFieldValue('extensionDate', value, true)
                        }
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        label="Enviar email - Prórroga"
                        checked={Boolean(formik.values.sendEmailExtension)}
                        disabled={!isStatusExtension}
                        onChange={() => {
                            formik.setFieldValue(
                                'sendEmailExtension',
                                !formik.values.sendEmailExtension
                            );
                        }}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha alerta SFC"
                        name="alertSFCDate"
                        size="small"
                        disabled
                        touched={formik.touched.alertSFCDate}
                        errors={formik.errors.alertSFCDate?.toString()}
                        value={formik.values.alertSFCDate}
                        minDate={dayjs(props.createdAt).subtract(5, 'hours')}
                        onChange={(value) =>
                            formik.setFieldValue('alertSFCDate', value, true)
                        }
                        showCustomValueWhenDisabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de respuesta"
                        name="responseDate"
                        size="small"
                        disabled={!(isClosingStatus || isStatusSolution)}
                        required={isClosingStatus || isStatusSolution}
                        touched={formik.touched.responseDate}
                        errors={formik.errors.responseDate?.toString()}
                        value={formik.values.responseDate}
                        minDate={minResponseDate}
                        maxDate={
                            formik.values.notificationResponseDate
                                ? dayjs(formik.values.notificationResponseDate)
                                : dayjs()
                        }
                        onChange={(value) =>
                            formik.setFieldValue('responseDate', value, true)
                        }
                        showCustomValueWhenDisabled
                        customDisabledValue="POR DEFINIR"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        label="Enviar email - Respuesta"
                        checked={Boolean(formik.values.sendEmailResponse)}
                        disabled={
                            isFollowUpStatus ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusOpen ||
                            isStatusProcessed ||
                            isStatusExtension ||
                            isStatusCancelled
                        }
                        onChange={() => {
                            formik.setFieldValue(
                                'sendEmailResponse',
                                !formik.values.sendEmailResponse
                            );
                        }}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de SAC"
                        name="sacDate"
                        size="small"
                        required={
                            isClosingStatus ||
                            isFollowUpStatus ||
                            isStatusExtensionInfo ||
                            isStatusReceptionInfo ||
                            isStatusSolution ||
                            isStatusProcessed ||
                            isStatusExtension
                        }
                        touched={formik.touched.sacDate}
                        errors={formik.errors.sacDate?.toString()}
                        value={
                            formik.values.sacDate
                                ? dayjs(formik.values.sacDate)
                                : undefined
                        }
                        minDate={dayjs(props.createdAt).subtract(5, 'hours')}
                        onChange={(value) =>
                            formik.setFieldValue('sacDate', value, true)
                        }
                        showCustomValueWhenDisabled
                        disabled={isDisabledSacAndFurag()}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de Furag"
                        name="furagDate"
                        size="small"
                        touched={formik.touched.furagDate}
                        errors={formik.errors.furagDate?.toString()}
                        value={
                            formik.values.furagDate
                                ? dayjs(formik.values.furagDate)
                                : undefined
                        }
                        minDate={dayjs(props.createdAt).subtract(5, 'hours')}
                        onChange={(value) =>
                            formik.setFieldValue('furagDate', value, true)
                        }
                        showCustomValueWhenDisabled
                        disabled={isDisabledSacAndFurag()}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        label="Habilitar edición - Fecha SAC y Furag"
                        checked={Boolean(formik.values.editFuragAndSac)}
                        onChange={() => {
                            formik.setFieldValue(
                                'editFuragAndSac',
                                !formik.values.editFuragAndSac
                            );
                        }}
                        onBlur={formik.handleBlur}
                        disabled={type !== 'admin'}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de notif, respuesta"
                        name="notificationResponseDate"
                        size="small"
                        disabled={!(isClosingStatus || isStatusSolution)}
                        required={isClosingStatus || isStatusSolution}
                        touched={formik.touched.notificationResponseDate}
                        errors={formik.errors.notificationResponseDate?.toString()}
                        value={formik.values.notificationResponseDate}
                        minDate={minNotificationResponseDate}
                        maxDate={
                            formik.values.notificationResponseDate
                                ? dayjs(formik.values.notificationResponseDate)
                                : dayjs()
                        }
                        onChange={(value) =>
                            formik.setFieldValue(
                                'notificationResponseDate',
                                value,
                                true
                            )
                        }
                        showCustomValueWhenDisabled
                        customDisabledValue="POR DEFINIR"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de cierre"
                        name="closingDate"
                        size="small"
                        required={
                            isClosingStatus ||
                            Boolean(formik.values.closingDate)
                        }
                        disabled={!isClosingStatus}
                        touched={formik.touched.closingDate}
                        errors={formik.errors.closingDate?.toString()}
                        value={formik.values.closingDate}
                        minDate={minClosedDate}
                        maxDate={maxClosedDate}
                        onChange={(value) =>
                            formik.setFieldValue('closingDate', value, true)
                        }
                        showCustomValueWhenDisabled
                        customDisabledValue="POR DEFINIR"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FieldText
                        label="Observación"
                        name="observation"
                        size="small"
                        required
                        rows={3}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.observation}
                        errors={formik.errors.observation}
                        value={formik.values.observation}
                        onChange={formik.handleChange}
                    />
                </Grid>
            </Grid>
        </>
    );
};
